import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__avatar",
  "use": "general__avatar-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"general__avatar\">\n  <g fill=\"none\" stroke-width=\"1.5\">\n    <circle cx=\"13\" cy=\"6.25\" r=\"5.75\" />\n\n    <path d=\"M13.083 15.664c2.848.002 5.622-.721 7.699-.659 2.012.061 3.959 5.6 4.206 7.769.138 1.215-.946 2.226-2.103 2.226l-19.78 0c-1.156 0-2.257-1.013-2.102-2.226.275-2.165 2.647-7.705 4.415-7.769 2.032-.073 4.88.657 7.7.659\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol